<template>
  <v-card flat class="conteneurLead" id="conteneurLead" style="width: 100%;">
    <v-card-title class="primary white--text" style="height: 52px; padding: 0px;">
      <v-btn icon @click="$emit('justCloseDialogConfirm')"><v-icon class="white--text">close</v-icon></v-btn>
      <div class="title tf_title_dialog" v-html="titleDialogConfirm"></div>
    </v-card-title>

    <v-card-text>
      <v-layout row wrap>
        <v-flex xs12>
          <div v-html="contentDialogConfirm"></div>
        </v-flex>

        <v-flex xs12 class="mt-3">
          <v-select
            v-model="selectActionPrompt"
            :items="computedActionUrl"
            item-text="text"
            item-value="id"
            label="Section du prompt"
          ></v-select>
        </v-flex>

        <v-flex xs12>
          <v-textarea
            :value="getCurrentPromptValue()"
            label="Prompt actuel"
            readonly
            auto-grow
            rows="8"
            outline
          ></v-textarea>
        </v-flex>
      </v-layout>
    </v-card-text>

    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn flat @click="closeDialogConfirm()">{{ $t('close') }}</v-btn>
      <v-btn
        color="primary"
        :loading="loadingEnhance"
        :disabled="loadingEnhance || !selectedPromptField()"
        @click="enhancePromptWithAI"
      >
        Améliorer avec IA
      </v-btn>
    </v-card-actions>

    <v-dialog
      v-model="showDialogComparePrompt"
      persistent
      scrollable
      max-width="90%"
    >
      <v-card>
        <v-card-title class="primary white--text compare-title">
          <v-btn icon dark @click="closeCompareDialog">
            <v-icon>close</v-icon>
          </v-btn>
          <span class="title compare-title-text">Comparaison des prompts</span>
        </v-card-title>
        <v-card-text class="compare-body">
          <div class="mb-3">
            <strong>Section:</strong> {{ selectedPromptField() }}
          </div>
          <v-layout row wrap>
            <v-flex xs12 md6 class="pr-3 compare-col">
              <h3 class="mb-2 compare-label">Prompt actuel</h3>
              <v-textarea
                :value="getCurrentPromptValue()"
                readonly
                auto-grow
                rows="12"
                outline
              ></v-textarea>
            </v-flex>
            <v-flex xs12 md6 class="pl-3 compare-col">
              <h3 class="mb-2 compare-label">Prompt amélioré</h3>
              <v-textarea
                :value="enhancedPrompt"
                readonly
                auto-grow
                rows="12"
                outline
              ></v-textarea>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-card-actions>
          <v-btn flat @click="closeCompareDialog">{{ $t('close') }}</v-btn>
          <v-spacer></v-spacer>
          <v-btn
            color="warning"
            :disabled="!enhancedPrompt.length || !selectedPromptField()"
            @click="openConfirmApplyDialog"
          >
            Appliquer ce prompt
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="showDialogConfirmApply"
      persistent
      max-width="560"
    >
      <v-card>
        <v-card-title class="headline">Confirmation</v-card-title>
        <v-card-text>
          Le prompt actuel de la section <strong>{{ selectedPromptField() }}</strong> sera remplacé par la version améliorée.
          <br>
          Voulez-vous continuer ?
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat @click="showDialogConfirmApply = false">Annuler</v-btn>
          <v-btn color="warning" @click="confirmApplyEnhancedPrompt">Confirmer</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
export default {
  props: {
    showDialogConfirmation: {
      type: Boolean,
      default: false
    },
    titleDialogConfirm: {
      type: String,
      default: 'Améliorer le prompt avec l\'I.A.'
    },
    contentDialogConfirm: {
      type: String,
      default: ''
    },
    contentDialogRes: {
      type: String,
      default: ''
    },
    startLoading: {
      type: Number,
      default: 0
    },
    endLoading: {
      type: Number,
      default: 0
    },
    loadingRes: {
      type: Boolean,
      default: false
    },
    closeDialogUniquement: {
      type: Boolean,
      default: false
    },
    currentPromptData: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      selectActionPrompt: '',
      loadingEnhance: false,
      showDialogComparePrompt: false,
      showDialogConfirmApply: false,
      enhancedPrompt: ''
    }
  },
  computed: {
    computedActionUrl () {
      return [
        {text: this.$t('personality'), id: 'personality'},
        {text: this.$t('environment'), id: 'environment'},
        {text: this.$t('objectif'), id: 'objectif'},
        {text: this.$t('communication'), id: 'communication'},
        {text: this.$t('questions'), id: 'questions'},
        {text: this.$t('rules'), id: 'rules'},
        {text: this.$t('tools'), id: 'tools'},
        {text: this.$t('custom'), id: 'custom'}
      ]
    }
  },
  methods: {
    closeDialogConfirm () {
      if (!this.closeDialogUniquement) {
        this.$emit('closeDialogConfirm')
      } else {
        this.$emit('justCloseDialogConfirm')
      }
    },
    selectedPromptField () {
      if (typeof this.selectActionPrompt === 'string' && this.selectActionPrompt.length) {
        return this.selectActionPrompt
      }
      return ''
    },
    getCurrentPromptValue () {
      const field = this.selectedPromptField()
      if (!field || !this.currentPromptData) return ''
      return this.currentPromptData[field] || ''
    },
    async enhancePromptWithAI () {
      const field = this.selectedPromptField()
      if (!field) return

      const currentValue = this.getCurrentPromptValue()
      const dataToPost = new window.FormData()
      dataToPost.append('section', field)
      dataToPost.append('current_prompt', currentValue)
      dataToPost.append('prompt_context', JSON.stringify(this.currentPromptData || {}))

      this.loadingEnhance = true
      this.enhancedPrompt = ''

      try {
        const response = await this.axios.post('post/enhance_openai_prompt.php', dataToPost, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}})
        const enhanced = typeof response.data === 'string' ? response.data : ''
        this.enhancedPrompt = enhanced.trim()
        this.showDialogComparePrompt = true
      } catch (_) {
        this.enhancedPrompt = ''
      } finally {
        this.loadingEnhance = false
      }
    },
    closeCompareDialog () {
      this.showDialogComparePrompt = false
      this.showDialogConfirmApply = false
    },
    openConfirmApplyDialog () {
      if (!this.enhancedPrompt.length) return
      this.showDialogConfirmApply = true
    },
    confirmApplyEnhancedPrompt () {
      const field = this.selectedPromptField()
      if (!field || !this.enhancedPrompt.length) return

      this.$emit('applyEnhancedPromptSection', field, this.enhancedPrompt)
      this.showDialogConfirmApply = false
      this.closeCompareDialog()
      this.closeDialogConfirm()
    }
  }
}
</script>

<style scoped>
.tf_title_dialog {
  text-overflow: ellipsis;
  width: calc(100% - 100px);
  overflow: hidden;
  white-space: nowrap;
}
.compare-col {
  margin-bottom: 12px;
}
.compare-body {
  padding-left: 16px !important;
  padding-right: 16px !important;
}
.compare-body .layout {
  margin-left: 0;
  margin-right: 0;
}
.compare-body .flex {
  padding-left: 0;
  padding-right: 0;
}
.compare-label {
  margin-left: 0;
}
.compare-title {
  align-items: center;
}
.compare-title-text {
  line-height: 1.2;
}
</style>



// WEBPACK FOOTER //
// src/components/watcheezy/WzDialogEnhancePrompt.vue